<template>
  <div class="display-join" />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DisplayJoin',

  props: {
    room: {
      type: String,
      required: true,
    },

    server: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    retryTimer: null,
  }),

  async created() {
    await this.connectDisplay();
  },

  beforeDestroy() {
    clearTimeout(this.retryTimer);
  },

  methods: {
    ...mapActions('synclounge', [
      'SET_AND_CONNECT_AND_JOIN_ROOM',
      'DISCONNECT_IF_CONNECTED',
    ]),

    ...mapActions('plex', [
      'FETCH_PLEX_DEVICES_IF_NEEDED',
    ]),

    async connectDisplay() {
      try {
        await this.FETCH_PLEX_DEVICES_IF_NEEDED();
        await this.DISCONNECT_IF_CONNECTED();
        await this.SET_AND_CONNECT_AND_JOIN_ROOM({
          server: this.server,
          room: this.room,
        });

        if (this.$route.name === 'DisplayJoin') {
          await this.$router.replace({
            name: 'DisplayPlayer',
            params: {
              room: this.room,
              ...(this.server && { server: this.server }),
            },
          });
        }
      } catch (error) {
        console.error('Dedicated display connection failed; retrying', error);
        this.retryTimer = setTimeout(this.connectDisplay, 5000);
      }
    },
  },
};
</script>

<style scoped>
.display-join {
  position: fixed;
  inset: 0;
  background: #000;
}
</style>
